module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-content-center align-items-center form-data"
  }, [_c('div', [(_vm.showConfirmAccount) ? _c('div', {
    staticClass: "px-3 py-2 mb-3 bg-lighter border-darker radius-normal"
  }, [_c('h4', {
    staticClass: "mb-1 darker mt-0 bold"
  }, [_vm._v("Your account was successfully created!")]), _vm._v(" "), _c('p', {
    staticClass: "fs-small darker"
  }, [_vm._v("\n                We've sent a confirmation email to your address, once you validate your account it will be ready to use.\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.showConfirmedAccount) ? _c('div', {
    staticClass: "px-3 py-2 mb-3 bg-lighter border-darker radius-normal"
  }, [_c('h4', {
    staticClass: "mb-1 darker mt-0 bold"
  }, [_vm._v("Your account was successfully confirmed!")]), _vm._v(" "), _c('p', {
    staticClass: "fs-small darker"
  }, [_vm._v("\n                All set! You can now login with your brand new account, enjoy!\n            ")])]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "mb-3"
  }, [_vm._v("Sign in to Pluralo")]), _vm._v(" "), _c('div', {
    staticClass: "dark mb-5"
  }, [_vm._v("Enter your details below.")]), _vm._v(" "), _c('form', {
    class: ['shaded', _vm.status],
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.triggerLogin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Email\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "full",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "autofocus": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Password\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "full",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('input', {
    staticClass: "btn action widest full",
    attrs: {
      "type": "submit",
      "value": "Sign in",
      "disabled": _vm.getIsTryingLogin
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "fs-smaller back",
    attrs: {
      "to": {
        name: 'auth.signup.forgot'
      }
    }
  }, [_vm._v("\n                Forgot your password?\n            ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484078b8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Login.vue
// module id = 2277
// module chunks = 0